import { BILLING_API } from '@Constants/backendConstants';
import { usePagedListApi } from '@Hooks/useListApi';
import { EnumInvoiceType } from '@Model';
import { InvoiceSnapshotsRepository } from '@Repositories/Billing';
import {
    EnumFilterExpressionOperation,
    EnumOperation,
    FilterCondition,
    ListRequest,
} from '@synqo/frontend-component-library';

// @ai-generated 2026-08-13T10:50:31+00:00 by malte.ulfers@tngtech.com using Claude Opus 5
export function useLoadUnpaidInvoiceSnapshots() {
    const listApi = usePagedListApi(InvoiceSnapshotsRepository, BILLING_API);

    function loadPage(listRequest: ListRequest) {
        // Mirrors the internal OPOS filters in useLoadUnpaidInvoices, minus its process_state check:
        // snapshots carry no process_state because they exist only once the invoice is approved.
        const oposFilters: FilterCondition[] = [
            {
                field: 'type',
                value: EnumInvoiceType.Cancellation.toString(),
                operator: EnumOperation.NotEqual,
            },
            { field: 'payment_completed_at', value: '', operator: EnumOperation.Equal },
            { field: 'related_cancellation.foreign_key', value: '', operator: EnumOperation.Equal },
            { field: 'total_gross_price', value: '0', operator: EnumOperation.NotEqual },
        ];

        if (listRequest.filter_columns === undefined) {
            listRequest.filter_columns = { operation: EnumFilterExpressionOperation.And, filters: [] };
        }

        listRequest.filter_columns.filters.push(...oposFilters);

        return listApi.loadPage(listRequest);
    }

    return { loadPage };
}
